import { MenuIcon } from '@assets/icons'
import { useWithAmpli } from '@contexts/AmpliContextProvider'
import { useIsCorporateDataEnabled } from '@hooks/useCorporateData'
import BusinessIcon from '@mui/icons-material/Business'
import ContactPhoneIcon from '@mui/icons-material/ContactPhone'
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined'
import WebAssetIcon from '@mui/icons-material/WebAsset'
import { List } from '@mui/material'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { BottomDiv, Drawer, MenuButtonBox, Toolbar } from './styles'
import { ToolbarItem } from './ToolbarItem'

const Menu = () => {
	const { t } = useTranslation()
	const withAmpli = useWithAmpli()

	const { isCorporateDataEnabled } = useIsCorporateDataEnabled()

	const handleCO2Click = useCallback(() => {
		withAmpli(ampli =>
			ampli.clickEvent({
				buttonText: 'Click CO2AI',
				clickPageUrl: window.location.href,
			})
		)
	}, [withAmpli])

	return (
		<Drawer variant="permanent">
			<Toolbar>
				<MenuButtonBox>
					<MenuIcon />
				</MenuButtonBox>
			</Toolbar>

			<List>
				<ToolbarItem
					text={t('menu.dashboard')}
					linkPath="/"
					IconComponent={SpaceDashboardOutlinedIcon}
				/>
				<ToolbarItem
					text={t('menu.suppliers')}
					linkPath="/customer/suppliers"
					IconComponent={ContactPhoneIcon}
					data-testid="suppliers-menu-item"
				/>
				<ToolbarItem
					text={t('menu.productEmissions')}
					linkPath="/products"
					IconComponent={EnergySavingsLeafIcon}
				/>
				{isCorporateDataEnabled && (
					<ToolbarItem
						text={t('menu.corporateData')}
						linkPath="/corporate-data"
						IconComponent={BusinessIcon}
					/>
				)}
			</List>
			<BottomDiv>
				<List>
					<ToolbarItem
						isExternalUrl
						text={t('menu.helpCenter')}
						linkPath="https://knowledge.co2ai.com/ecosystem/how-to-start"
						IconComponent={HelpOutlineIcon}
					/>
					<ToolbarItem
						text={t('menu.settings')}
						linkPath="/settings"
						IconComponent={SettingsOutlinedIcon}
					/>
					<ToolbarItem
						isExternalUrl
						text={t('menu.co2ai')}
						linkPath="https://www.co2ai.com/"
						IconComponent={WebAssetIcon}
						onClick={handleCO2Click}
					/>
					<ToolbarItem
						text={t('menu.logout')}
						linkPath="/logout"
						IconComponent={LogoutOutlinedIcon}
					/>
				</List>
			</BottomDiv>
		</Drawer>
	)
}

export { Menu }
